import * as React from 'react';

interface shoeProps {
  theme?: 'night' | 'day';
  children: React.ReactNode;
}
export default function Shoe(props: shoeProps) {
  const { theme = 'day' } = props;

  return <div className={`shoe ${theme}`}>{props.children}</div>;
}
